export enum Status {
    WRITING = "writing",
    REVIEWING = "waiting for review",
    APPROBATING = "waiting for approval",
    REFUSED = "waiting resume",
    PUBLISHED = "published",
    ARCHIVED = "archived",
    WAITING= "waiting for resume"
  }